import { render, staticRenderFns } from "./SerpTitles.vue?vue&type=template&id=78293a0c&scoped=true&"
import script from "./SerpTitles.vue?vue&type=script&lang=js&"
export * from "./SerpTitles.vue?vue&type=script&lang=js&"
import style0 from "./SerpTitles.vue?vue&type=style&index=0&id=78293a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78293a0c",
  null
  
)

/* custom blocks */
import block0 from "./SerpTitles.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports